<template>
    <!-- 道具合成 -->
    <el-dialog class="wrap" title="请选择" :visible.sync="composeItemTableVisible" :before-close="compose_item_dialog_close" append-to-body>
            <div class="itembg" v-if="'' != composeFormulaBOList" v-loading="loading">
                <div id="itemlist">
                    <div v-for="(item,index) in composeFormulaBOList" v-bind:key="index" ref="itemType" class="itemTypediv" :id="item.id + '_item'">
                        <label :for="item.id">
                            <span v-text="item.resultItem" @click="composeItem(item.id);"></span>
                        </label>
                    </div>
                </div>
            </div>
        </el-dialog>
</template>

<script>
import {postRequest} from '../../utils/api'
import {getRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'composeItem',
  props:{
    composeItemTableVisible: {
      type: Boolean,
      default: false
    },
    composeFormulaBOList: Array
  },
  data() {
    return {
        loading: false,
    };
  },
  watch: {
    composeItemTableVisible: {
      handler(newVal) {
        if (newVal === true) {
          // 触发刷新（如果需要）
        }
      }
    }
  },
  methods: {
    compose_item_dialog_close(){
      this.$emit("compose_item_dialog_close");
    },


    //合成道具
    composeItem: function(value){
        let _this = this;
        this.$confirm('您确定要进行制作吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.loading = true;
            postRequest('/item/specialEvent/composeItems', {
                composeId: value
            }).then(resp=> {
              _this.loading = false;
              _this.$emit("compose_item_dialog_close");
              if (resp.status == 200) {
                //成功
                var respData = resp.data;
                if (200 == respData.status) {
                    Message.success(respData.message);
                    _this.$store.dispatch('user/fetchUserDetail');
                } else {
                    Message.error(respData.message);
                }
              } else {
              //失败
                Message.error('用户非法⊙﹏⊙∥!');
              }
            }, resp=> {
              _this.loading = false;
              Message.error('用户非法⊙﹏⊙∥!');
            });
        }, function () {
            //取消
        })
    },
  }
}
</script>

<style scoped>
.wrap {
    margin:auto;
}
.itembg {
    width:100%;
    height: 300px;
}
#itemtitle {
	padding:3px 5px;
	background-color:#72b653;
	font-size:16px;
	font-weight:bold;
	color:#fff;
	letter-spacing:5px;
	text-align:center;
}
#itemlist {
	text-align:center;
  width: 100%;
  height:100%;
	float:left;
  overflow-y: auto;
}
#itemContent {
  width: 40%;
  height:100%;
	float: right;
  margin-top: 30px;
}
.itemTypediv {
	height:30px;
	margin:3px 5px;
	width:90%;
  border:1px solid #0000ff;
}
.itemTypediv label {
	text-align:center;
  height: 100%;
	width:100%;
	font-size:16px;
  line-height: 30px;
  display: inline-block;
	cursor: pointer;
}
.itemTypediv input {
  display: none;
}

/* 无道具时，提示语显示的样式 */
.noItems, .noSelected {
	padding:3px 5px;
	font-size:16px;
	font-weight:bold;
	letter-spacing:5px;
	text-align:center;
    height: 100px;
    line-height: 100px;
}

.iteminfo .infoline {
	height: 40px;
    line-height: 40px;
    vertical-align:middle;
    margin: 5px;
}
.iteminfo .infoline img {
	height: 40px;
    width: 40px;
    line-height: 40px;
    vertical-align:middle;
}
.iteminfo .materials {
    margin: 5px;
}
.iteminfo .materials .materialline img {
	height: 24px;
    width: 24px;
    line-height: 24px;
    vertical-align:middle;
}
</style>